import { useMemo } from "react";
import { formatCurrency, formatDate, formatPhoneNumber } from "../helper";

const ContractInfoRow = ({
  label,
  value,
  isCurrency = false,
  isLink = false,
  isPhone = false,
  isDate = false,
  isBoolean = false,
  labelClassName,
  linkText = "View",
}: {
  label: string;
  value: string | number | Date;
  isCurrency?: boolean;
  isLink?: boolean;
  isPhone?: boolean;
  isDate?: boolean;
  isBoolean?: boolean;
  labelClassName?: string;
  linkText?: string;
}) => {
  const renderValue = useMemo(() => {
    if (isBoolean) {
      return value ? "Yes" : "No";
    }

    if (isDate) {
      return formatDate(value as Date, "N/A");
    }

    if (!value || typeof value === "object") {
      return "N/A";
    }

    if (isLink) {
      return (
        <a
          href={value as string}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 font-medium underline underline-offset-4"
        >
          {linkText}
        </a>
      );
    }

    if (isPhone) {
      return formatPhoneNumber(value as string, "N/A");
    }

    if (isCurrency) {
      return formatCurrency(+value);
    }

    return value;
  }, [value, isBoolean, linkText, isLink, isPhone, isDate, isCurrency]);

  return (
    <div className="min-[460px]:flex grid items-center gap-1 text-sm">
      <p className={`text-gray-900 font-medium ${labelClassName}`}>{label}</p>
      <p
        className={`text-gray-600 break-all ${isCurrency ? "text-right" : ""}`}
      >
        {renderValue}
      </p>
    </div>
  );
};

export default ContractInfoRow;
